module.exports = __webpack_public_path__ + "static/kiteboarding-jump-2dad1cc5787e658609e76767c992ad9f.jpg";